module.exports = __webpack_public_path__ + "static/img/Honda_ROBOTS_0009_09_B18_4.66adf77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Honda_ROBOTS_0009_09_B18_4.jpg
// module id = RoYx
// module chunks = 0